// Women's Perfumes - Ranked by Popularity & Sales
// Difficulty: DIFFICULT - Fragrance culture knowledge required

export const perfumesData = [
  { id: 1, name: "Chanel No. 5", rank: 1, image: "/images/perfumes/chanel_no5.png" },
  { id: 2, name: "J'adore (Dior)", rank: 2, image: "/images/perfumes/j_adore.png" },
  { id: 3, name: "Coco Mademoiselle (Chanel)", rank: 3, image: "/images/perfumes/coco_mademoiselle.png" },
  { id: 4, name: "Black Opium (YSL)", rank: 4, image: "/images/perfumes/black_opium.png" },
  { id: 5, name: "La Vie Est Belle (Lancôme)", rank: 5, image: "/images/perfumes/la_vie_est_belle.png" },
  { id: 6, name: "Daisy (Marc Jacobs)", rank: 6, image: "/images/perfumes/daisy.png" },
  { id: 7, name: "Flowerbomb (Viktor & Rolf)", rank: 7, image: "/images/perfumes/flowerbomb.png" },
  { id: 8, name: "Miss Dior", rank: 8, image: "/images/perfumes/miss_dior.png" },
  { id: 9, name: "Good Girl (Carolina Herrera)", rank: 9, image: "/images/perfumes/good_girl.png" },
  { id: 10, name: "Chance (Chanel)", rank: 10, image: "/images/perfumes/chance.png" },
  { id: 11, name: "Light Blue (D&G)", rank: 11, image: "/images/perfumes/light_blue.png" },
  { id: 12, name: "Sì (Armani)", rank: 12, image: "/images/perfumes/si.png" },
  { id: 13, name: "Mon Paris (YSL)", rank: 13, image: "/images/perfumes/mon_paris.png" },
  { id: 14, name: "Libre (YSL)", rank: 14, image: "/images/perfumes/libre.png" },
  { id: 15, name: "Bloom (Gucci)", rank: 15, image: "/images/perfumes/gucci_bloom.png" },
  { id: 16, name: "Angel (Mugler)", rank: 16, image: "/images/perfumes/angel.png" },
  { id: 17, name: "Chloé", rank: 17, image: "/images/perfumes/chloe.png" },
  { id: 18, name: "Euphoria (Calvin Klein)", rank: 18, image: "/images/perfumes/euphoria.png" },
  { id: 19, name: "Bombshell (Victoria's Secret)", rank: 19, image: "/images/perfumes/bombshell.png" },
  { id: 20, name: "Alien (Mugler)", rank: 20, image: "/images/perfumes/alien.png" },
  { id: 21, name: "Very Good Girl (Carolina Herrera)", rank: 21, image: "/images/perfumes/very_good_girl.png" },
  { id: 22, name: "Her (Burberry)", rank: 22, image: "/images/perfumes/burberry_her.png" },
  { id: 23, name: "Hypnotic Poison (Dior)", rank: 23, image: "/images/perfumes/hypnotic_poison.png" },
  { id: 24, name: "Idôle (Lancôme)", rank: 24, image: "/images/perfumes/idole.png" },
  { id: 25, name: "Delina (Parfums de Marly)", rank: 25, image: "/images/perfumes/delina.png" },
];
